module.exports = __webpack_public_path__ + "img/CHATGP.f59e236c.jpg";